'use client';

import { reactMarkdownConfig } from '@/lib/utils/strapi';
import ReactMarkdown from 'react-markdown';

export default function PrivacyPolicy({ info }: { info: string }) {
  return (
    <section className="">
      <div className="flex flex-col items-center justify-center">
        <ReactMarkdown className="prose max-w-full " {...reactMarkdownConfig}>
          {info}
        </ReactMarkdown>
      </div>
    </section>
  );
}
